<template>
  <pdp-section-ctas />
</template>

<script lang="ts" setup>
import PdpSectionCtas from '#commerce/components/pdp/section/Ctas.vue'

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().pages.pdp

if ($feature.tempShowATCAboveFold) {
  brandClasses.ctasWrapper = 'mt-6 pb-10 space-y-4 lg:mt-4'
}
</script>
